export const DEFAULT_MARQUEE_SPEED = 88;

export function calculateMarqueeMotion({ viewportWidth, textWidth, speed = DEFAULT_MARQUEE_SPEED } = {}) {
  const viewport = Math.max(0, Math.ceil(Number(viewportWidth) || 0));
  const text = Math.max(0, Math.ceil(Number(textWidth) || 0));
  const pixelsPerSecond = Math.max(1, Number(speed) || DEFAULT_MARQUEE_SPEED);
  const distance = viewport + text;
  return {
    start: viewport,
    end: -text,
    distance,
    duration: distance > 0 ? Number((distance / pixelsPerSecond).toFixed(3)) : 0
  };
}
